import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { connect, ConnectedProps } from 'react-redux';
import { StoreState } from '../../types/state';
import { Notification } from '../../types/index';

import 'react-toastify/dist/ReactToastify.css';

const mapStateToProps = (state: StoreState) => {
  return {
    messages: state.notifications.messages as Notification[],
    ShownAll: state.notifications.isShownAllMessages,
  };
};

const connector = connect(mapStateToProps, null);

type notificationBoundaryProps = ConnectedProps<typeof connector>;

const toastTypes = {
  info: toast.info,
  success: toast.success,
  warning: toast.warn,
  error: toast.error,
};

const NotificationBoundary = (props: notificationBoundaryProps) => {
  const { ShownAll, messages } = props;
  useEffect(() => {
    if (ShownAll || messages.length === 0) return;

    messages.forEach((el) => {
      const toast = toastTypes[el.type];
      toast(el.message, {
        toastId: `toast_${el.id}`,
      });
    });
  }, [messages, ShownAll]);
  return <ToastContainer hideProgressBar={false} position="top-right" />;
};

export default connector(NotificationBoundary);
